import React, { useEffect, useState } from "react";
import { Breadcrumb, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import TaskForm from "./taskForm";
import TaskModal from "./taskModal";
import { DocumentChartBarIcon, HomeIcon } from "@heroicons/react/16/solid";
import { getRequest } from "../../utils/APICall";

const Tasks = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [projects, setProjects] = useState([]);
  const [tableReFetchData, setTableReFetchData] = useState(0);

  const getAllProjects = async () => {
    // const cached = sessionStorage.getItem("allProjects");
    // console.log(cached, "........................");

    // if (cached) {
    //   setProjects(JSON.parse(cached));
    // }
    const res = await getRequest("getAllProjects");
    // console.log(res)
    if(res?.success){
      setProjects(res?.data);
    }else{
      setProjects([])
    }
    // sessionStorage.setItem("allProjects", JSON.stringify(res?.data));
    // console.log("chal bahi",res)
  };

  useEffect(() => {
    getAllProjects();
  }, []);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedTask(null);
  };

  const handleEdit = async (taskData) => {
    // console.log(taskData)
    // const data = await getRequest(`getTaskById?taskId=${taskData.ID}`);
    // console.log("task by id ",data)
    if (taskData) {
      // console.log("data?.tasks")
      setSelectedTask(taskData);
      setIsModalOpen(true);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setSelectedTask(null);
  };

  const breadcrumbItems = [
    {
      href: "/",
      title: (
        <span className="flex gap-2 items-center">
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg">Home</span>
        </span>
      ),
    },
    {
      href: "#",
      title: (
        <span className="flex gap-2 items-center">
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className="text-gray-400 sm:text-lg">Task</span>
        </span>
      ),
    },
  ];

  return (
    <div className="p-4 md:p-6 lg:p-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <span className="flex flex-wrap gap-4 justify-between items-start md:items-center w-full">
          <span className="flex flex-col gap-2 text-xl md:text-4xl font-black w-full md:w-auto">
            Task
            <Breadcrumb items={breadcrumbItems} />
          </span>
        </span>
        <div className="flex gap-2 mt-4 md:mt-0">
          <Button
            className="bg-green-400 font-bold lg:text-xl text-black py-6 px-4"
            variant="filled"
            icon={<PlusOutlined />}
            onClick={showModal}
          >
            Add Task
          </Button>
        </div>
      </div>

      <div className="mt-6">
        <TaskForm
          onEdit={handleEdit}
          tableReFetchData={tableReFetchData}
        />
      </div>

      <TaskModal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        selectedTask={selectedTask}
        setProjects={setProjects}
        projects={projects}
        setTableReFetchData={setTableReFetchData}

      />
    </div>
  );
};

export default Tasks;
